module.exports = __webpack_public_path__ + "img/scopelogo02.1d3fca7b.svg";